import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'product', // 资源路径
    defaultRels: ['attributes', 'productCate', 'banners', 'voices'], // 默认需要的关联数据
  }

})
